import sImg1 from "../images/services/service_image_1.webp";
import sImg2 from "../images/services/service_image_2.webp";
import sImg3 from "../images/services/service_image_3.webp";
import sImg4 from "../images/services/service_image_4.webp";
import sImg5 from "../images/services/service_image_5.webp";

import icon1 from "../images/icons/icon_code.svg";
import icon2 from "../images/icons/icon_programming_tree.svg";
import icon3 from "../images/icons/icon_monitor_2.svg";
import icon4 from "../images/icons/icon_phone.svg";
import icon5 from "../images/icons/icon_bug.svg";
import icon6 from "../images/icons/icon_programming.svg";

import icon7 from "../images/icons/icon_analisis_2.svg";
import icon8 from "../images/icons/icon_process.svg";
import icon9 from "../images/icons/icon_chart_2.svg";
import icon10 from "../images/icons/icon_meeting.svg";
import icon11 from "../images/icons/icon_bulb_2.svg";
import icon12 from "../images/icons/icon_speed_miter.svg";

const Services = [
  {
    Id: "1",
    sImg: sImg1,
    title: "IT Management Services",
    slug: "IT-Management-Services",
    thumb1: "Strategy",
    thumb2: "Consultation",
    col: "col-lg-6",
    description:
      "Visit new places to discover with a Tourist Visa. We deliver your documents ...",
  },
  {
    Id: "2",
    sImg: sImg2,
    title: "Data Tracking and Security",
    slug: "Data-Tracking-and-Security",
    thumb1: "Management",
    thumb2: "Transfer",
    col: "col-lg-6",
    description:
      "Developing your trade, setting up new sales channels Your visa is ready...",
  },
  {
    Id: "3",
    sImg: sImg3,
    title: "Website Development",
    slug: "Website-Development",
    thumb1: "Landing Page",
    thumb2: "Plugins",
    col: "col-lg-4",
    description:
      "Developing your trade, setting up new sales channels Your visa is ready...",
  },
  {
    Id: "4",
    sImg: sImg4,
    title: "Modern Technology Solution",
    slug: "Modern-Technology-Solution",
    thumb1: "Consultation",
    thumb2: "solution",
    col: "col-lg-4",
    description:
      "Embarking on a journey of higher education in a foreign country opens doors to...",
  },
  {
    Id: "5",
    sImg: sImg5,
    title: "UI/UX Design Services",
    slug: "UI-UX-Design-Services",
    thumb1: "Website",
    thumb2: "Mobile App",
    col: "col-lg-4",
    description:
      "Expert Guidance for a Seamless Immigration Journey Expert Guidance...",
  },
  {
    Id: "6",
    sImg: icon1,
    title: "Web Design Services",
    slug: "Web-Design-Services",
    description:
      "Our Web Design Services combine aesthetics, usability, and performance to create websites that captivate audiences and drive business results. At our IT solution agency, we design responsive, user-centric, and conversion-optimized websites tailored to your brand identity and business goals. From concept to code, our team ensures each project meets the highest standards of visual appeal and functionality.",
    features: [
      "Responsive Design",
      "Expertise in Design",
      "Client-Centered Approach",
      "Quality & Innovation",
      "Frontend Development",
    ],
    approach: [
      {
        title: "User-Centered Design",
        description:
          "We focus on designing experiences that prioritize the end user. Our approach is based on usability, accessibility, and audience behavior to maximize engagement and satisfaction.",
      },
      {
        title: "Mobile-First Development",
        description:
          "With the majority of users browsing on mobile, we start design with mobile responsiveness in mind — ensuring seamless functionality across all devices.",
      },
      {
        title: "Brand Integration",
        description:
          "Every design reflects your unique identity. We incorporate your brand colors, typography, and messaging into a cohesive, beautiful layout that builds recognition and trust.",
      },
    ],
    outcomeIntro:
      "Here are the outcomes you can expect when partnering with us for professional Web Design Services — results that blend creativity, usability, and innovation to support your business growth:",
    outcomeDetails: [
      {
        title: "Engaging User Experiences",
        description:
          "We design interfaces that guide users intuitively through your site, improving time on page, interaction, and conversions.",
      },
      {
        title: "Cross-Device Responsiveness",
        description:
          "Our designs adapt seamlessly to smartphones, tablets, and desktops, providing consistent performance and aesthetics across devices.",
      },
      {
        title: "Faster Load Times",
        description:
          "Optimized assets and clean code structure ensure that your website loads quickly — a critical factor for both SEO and user satisfaction.",
      },
      {
        title: "Visual Storytelling",
        description:
          "Through thoughtful layout, imagery, and typography, we help visually communicate your brand’s story and message effectively.",
      },
      {
        title: "SEO-Friendly Architecture",
        description:
          "We build websites with clean structure, meta tags, and optimized content to support organic search performance from day one.",
      },
      {
        title: "Scalable & Maintainable Code",
        description:
          "Our frontend architecture is built with scalability in mind — allowing for easy updates, future enhancements, and integration with other tools.",
      },
    ],
  },

  {
    Id: "7",
    sImg: icon2,
    title: "Web Development Services",
    slug: "Web-Development-Services",
    description:
      "Our Web Development Services are built to empower your business with fast, secure, and scalable websites and applications. Whether you're starting from scratch or upgrading an existing platform, we deliver custom-coded solutions tailored to your specific needs. From frontend aesthetics to backend logic and system integrations, we ensure every layer of your website functions smoothly to deliver a powerful digital experience.",
    outcomeIntro:
      "Our development services go beyond code — they’re designed to deliver business value, technical excellence, and long-term scalability. Here’s what you gain by partnering with us:",
    outcomeDetails: [
      {
        title: "Custom Development",
        description:
          "We build fully customized websites and web apps tailored to your brand, business logic, and customer journey — not cookie-cutter templates.",
      },
      {
        title: "Scalable Architecture",
        description:
          "Our solutions are built with growth in mind, using modern frameworks and clean code practices to support traffic spikes and feature expansion.",
      },
      {
        title: "CMS Integration",
        description:
          "We integrate powerful content management systems like WordPress, Strapi, or custom admin panels to give you full control over your site’s content.",
      },
      {
        title: "API & Third-Party Integration",
        description:
          "From payment gateways to CRM tools and external APIs, we ensure seamless integrations that expand your website’s functionality and improve user experience.",
      },
      {
        title: "Security & Performance",
        description:
          "We implement strong security protocols, SSL, and performance optimization (CDN, lazy loading, asset minification) to keep your platform fast and safe.",
      },
      {
        title: "Cross-Device & Cross-Browser Compatibility",
        description:
          "Your website will work flawlessly across all major browsers and devices, ensuring consistent performance and appearance everywhere.",
      },
    ],
    features: [
      "Custom Website Design & Development",
      "CMS Integration",
      "Backend Development",
      "API Development & Integration",
    ],
    approach: [
      {
        title: "Requirement Analysis",
        description:
          "We begin by deeply understanding your technical requirements, business goals, and target audience to plan the right development strategy.",
      },
      {
        title: "Architecture & Tech Stack Planning",
        description:
          "We define the system architecture and select the best-suited technologies and frameworks (React, Node.js, Laravel, etc.) for your project.",
      },
      {
        title: "Agile Development & Coding",
        description:
          "Our development process is agile and iterative, ensuring fast delivery, transparency, and the flexibility to evolve the product as needed.",
      },
      {
        title: "Testing & Quality Assurance",
        description:
          "We conduct rigorous testing — including unit, integration, and user acceptance tests — to ensure the platform is stable and bug-free.",
      },
      {
        title: "Deployment & Ongoing Support",
        description:
          "We handle secure deployment and continue to monitor, maintain, and optimize the site after launch to ensure peak performance.",
      },
    ],
  },
  {
    Id: "8",
    sImg: icon3,
    title: "Mobile Apps Development",
    slug: "Web-Application-Design-and-Development",
    description:
      "Our Mobile Apps Development services help businesses build high-performance, feature-rich applications that deliver great user experiences across all devices. Whether you need a native Android or iOS app, or a cross-platform solution, our team uses cutting-edge frameworks and clean code practices to turn your idea into a fully functional, scalable mobile product.",
    features: [
      "Android App Development",
      "iOS App Development",
      "Cross-Platform App Development",
      "Custom API Integration",
    ],
    approach: [
      {
        title: "User-Centric Design",
        description:
          "We start with user experience in mind — focusing on intuitive interfaces, seamless navigation, and engaging user flows.",
      },
      {
        title: "Native & Cross-Platform Strategy",
        description:
          "Depending on your goals and budget, we help you choose between native (Kotlin/Swift) or cross-platform (React Native/Flutter) for faster time-to-market.",
      },
      {
        title: "Agile Development Process",
        description:
          "We follow agile sprints, providing regular updates and iterations — allowing for flexibility and faster feedback-driven releases.",
      },
      {
        title: "Performance & Optimization",
        description:
          "From battery usage to launch speed and offline access, we ensure your app is light, responsive, and ready for real-world conditions.",
      },
      {
        title: "Security-First Architecture",
        description:
          "We build with encrypted data storage, secure APIs, authentication layers, and platform-specific best practices to protect user information.",
      },
    ],
    outcomeIntro:
      "By choosing our Mobile App Development services, you gain more than just a mobile presence — you gain a fully optimized, scalable product that users love. Here's what you can expect:",
    outcomeDetails: [
      {
        title: "High-Performance Mobile Experience",
        description:
          "Our apps are engineered for speed, responsiveness, and stability — ensuring smooth user experiences across all devices and OS versions.",
      },
      {
        title: "Cross-Platform Compatibility",
        description:
          "We deliver apps that work flawlessly on both Android and iOS, using tools like Flutter and React Native to reduce development time and cost.",
      },
      {
        title: "Custom Backend & API Integration",
        description:
          "From payment gateways to social logins and third-party services, we build robust backends and integrate APIs that enhance your app’s functionality.",
      },
      {
        title: "App Store Deployment Support",
        description:
          "We handle app store submission (Google Play and App Store), including compliance, assets, and versioning — ensuring a smooth launch process.",
      },
      {
        title: "Analytics & In-App Insights",
        description:
          "Integrate tools like Firebase or Mixpanel to monitor usage, track conversions, and gain actionable user insights post-launch.",
      },
      {
        title: "Ongoing Maintenance & Updates",
        description:
          "We provide continued support after deployment — adding new features, fixing bugs, and updating for the latest OS changes and user expectations.",
      },
    ],
  },
  {
    Id: "9",
    sImg: icon4,
    title: "Content Development Services",
    description:
      "In today’s hyper-digital world, Content Development Services are no longer just a marketing necessity—they are the strategic engine behind digital transformation and brand visibility. At our IT solution agency, we recognize that impactful content lies at the heart of successful online engagement, seamless communication, and scalable operations. We don't just produce content—we develop it with purpose, aligning every asset with your brand's voice, target audience, and digital goals. Whether you're a startup seeking visibility or an enterprise undergoing a transformation, our content strategies are customized to ensure you connect, convert, and scale effectively.",
    slug: "Content-Development-Services",
    outcomeIntro:
      "When you choose our Content Development Services, you're not just getting well-written material—you’re getting a strategic partner focused on measurable results. Here are six core benefits we deliver:",
    features: [
      "Expert Content Developers",
      "Original Content",
      "Descriptive & Engaging",
      "Client-Focused",
    ],
    outcomeDetails: [
      {
        title: "Expert Content Developers",
        description:
          "Our team is composed of skilled writers, editors, and strategists with deep industry knowledge. They craft tailored content that aligns with your brand voice, audience expectations, and business goals — ensuring quality, clarity, and purpose in every word.",
      },
      {
        title: "Original Content",
        description:
          "We prioritize authenticity. Every piece of content is developed from scratch, based on thorough research and your unique requirements — ensuring originality, avoiding plagiarism, and strengthening your brand’s credibility.",
      },
      {
        title: "Descriptive & Engagingn",
        description:
          "We turn complex ideas into clear, compelling content. With a balance of detail and storytelling, our writing keeps users informed and engaged — increasing dwell time, interaction, and conversion.",
      },
      {
        title: "Client-Focused",
        description:
          "We listen first, write second. Our content process is collaborative and feedback-driven — designed to reflect your brand’s voice, meet your objectives, and speak directly to your ideal audience.",
      }
    ],
    approach: [
      {
        title: "Strategic Planning",
        description:
          "Each piece of content is mapped to a goal—be it traffic generation, SEO rankings, lead conversion, or thought leadership.",
      },
      {
        title: "Audience-Centric Development",
        description:
          "We build content that resonates with your audience’s intent, pain points, and language.",
      },
      {
        title: "Platform Versatility",
        description:
          "From websites and apps to emails, blogs, whitepapers, and training manuals, our content is adaptable and consistent across all platforms.",
      },
    ],
  },

  {
    Id: "10",
    sImg: icon5,
    title: "Design Services",
    slug: "Design-Services",
    description:
      "Our Design Services are built to visually elevate your brand, enhance user experiences, and make a lasting impression across all digital and print platforms. Whether it’s UI/UX for apps, brand identity, website layouts, or marketing collateral, our creative team combines strategy with aesthetics to craft designs that communicate effectively and convert effortlessly.",
    features: [
      "UI/UX Design",
      "Logo Design",
      "Website Design/App Design",
      "Print Design",
      "Social Media Graphics",
    ],
    approach: [
      {
        title: "Creative Discovery & Research",
        description:
          "We begin every project with brand research, audience insights, and competitive analysis to design with purpose and clarity.",
      },
      {
        title: "User-Focused Design Thinking",
        description:
          "Our process is grounded in user experience principles, ensuring every design is intuitive, accessible, and goal-oriented.",
      },
      {
        title: "Brand Consistency",
        description:
          "We ensure your designs align with your brand identity across all touchpoints — from websites and mobile apps to print and digital media.",
      },
      {
        title: "Collaboration & Feedback",
        description:
          "We work closely with your team throughout the design process, incorporating feedback and iterating quickly to stay aligned with your vision.",
      },
      {
        title: "Design System & Handoff",
        description:
          "We provide scalable design systems, style guides, and developer-friendly assets to ensure a smooth design-to-development transition.",
      },
    ],
    outcomeIntro:
      "By choosing our Design Services, you're investing in more than visuals — you're gaining brand value, user trust, and creative differentiation. Here’s what our design work delivers:",
    outcomeDetails: [
      {
        title: "Improved Brand Identity",
        description:
          "From logos to color palettes, we create a cohesive visual language that strengthens brand recognition and professionalism.",
      },
      {
        title: "Enhanced User Experience",
        description:
          "Thoughtful UI/UX design reduces friction, increases engagement, and boosts conversion by guiding users through seamless journeys.",
      },
      {
        title: "Cross-Platform Visual Consistency",
        description:
          "We maintain visual harmony across mobile, web, and print — ensuring your brand looks sharp wherever it's seen.",
      },
      {
        title: "Increased Audience Engagement",
        description:
          "Compelling social media graphics and on-brand marketing creatives drive interaction, shares, and audience growth.",
      },
      {
        title: "Professional Print Materials",
        description:
          "From business cards to brochures, we design polished print materials that support offline branding and events.",
      },
      {
        title: "Design Scalability",
        description:
          "We create reusable components and design systems that allow your brand to grow without visual clutter or inconsistency.",
      },
    ],
  },
  {
    Id: "11",
    sImg: icon6,
    title: "SEO Services",
    slug: "SEO-Services",
    description:
      "Our SEO Services are designed to increase your website's visibility, drive qualified traffic, and boost your search engine rankings. We combine proven strategies with innovative techniques to ensure your business stays ahead in a competitive digital landscape. From technical audits and keyword research to on-page optimization and content planning, we cover every aspect of search engine optimization to deliver measurable results.",
    features: [
      "Skilled SEO Consultants",
      "Inventive Strategies",
      "Results-Driven Approach",
      "Industry-Wide Expertise",
      "Continuous Optimization",
    ],
    approach: [
      {
        title: "In-Depth SEO Audit",
        description:
          "We begin with a comprehensive website audit to identify technical issues, broken links, indexing problems, and performance bottlenecks.",
      },
      {
        title: "Keyword Research & Strategy",
        description:
          "We analyze search intent, volume, and competition to create a targeted keyword strategy that aligns with your business goals.",
      },
      {
        title: "On-Page Optimization",
        description:
          "From meta tags and internal linking to content structure and media, we optimize every page element for better rankings.",
      },
      {
        title: "Technical SEO Enhancements",
        description:
          "We address crawlability, mobile responsiveness, page speed, schema markup, and other technical SEO factors that influence search engine behavior.",
      },
      {
        title: "Link Building & Authority Development",
        description:
          "We build high-quality backlinks through ethical outreach, guest posting, and digital PR to boost domain authority.",
      },
      {
        title: "Performance Tracking & Reporting",
        description:
          "We track rankings, traffic, bounce rates, and conversions — providing regular, transparent reports and actionable insights.",
      },
    ],
    outcomeIntro:
      "Our SEO Services don’t just improve rankings — they elevate your entire digital presence. Here's what you can expect as outcomes of working with our expert SEO team:",
    outcomeDetails: [
      {
        title: "Higher Search Engine Rankings",
        description:
          "Through targeted strategies and technical improvements, your site climbs the rankings for relevant keywords in Google and other engines.",
      },
      {
        title: "Increased Organic Traffic",
        description:
          "With improved visibility and content relevance, we help you attract more qualified visitors from organic search.",
      },
      {
        title: "Improved Website Authority",
        description:
          "With ethical link-building and strong content, your domain earns trust from search engines and users alike.",
      },
      {
        title: "Better Conversion Rates",
        description:
          "We optimize landing pages and content funnels that not only rank well but convert traffic into leads and customers.",
      },
      {
        title: "Competitive Market Positioning",
        description:
          "Stay ahead of the competition with regular algorithm-friendly updates and trend-based optimization techniques.",
      },
      {
        title: "Long-Term Growth & ROI",
        description:
          "SEO is an investment — we focus on compounding growth, ensuring you get consistent traffic and visibility well into the future.",
      },
    ],
  },
  {
    Id: "12",
    sImg: icon7,
    title: "Strategic Planning and Execution",
    slug: "Strategic-Planning-and-Execution",
    description:
      "Our consulting services are customized to suit the unique needs and goals of each client, ensuring precise alignment with their business objectives.",
  },
  {
    Id: "13",
    sImg: icon8,
    title: "Business Process Optimization",
    slug: "Business-Process-Optimization",
    description:
      "Our consulting services are customized to suit the unique needs and goals of each client, ensuring precise alignment with their business objectives.",
  },
  {
    Id: "14",
    sImg: icon9,
    title: "Digital Transformation Consulting",
    slug: "Digital-Transformation-Consulting",
    description:
      "Our consulting services are customized to suit the unique needs and goals of each client, ensuring precise alignment with their business objectives.",
  },
  {
    Id: "15",
    sImg: icon10,
    title: "Strategic Planning and Execution",
    slug: "Strategic-Planning-and-Executions",
    description:
      "Our consulting services are customized to suit the unique needs and goals of each client, ensuring precise alignment with their business objectives.",
  },
  {
    Id: "16",
    sImg: icon11,
    title: "Change Management Solutions",
    slug: "Change-Management-Solutions",
    description:
      "Our consulting services are customized to suit the unique needs and goals of each client, ensuring precise alignment with their business objectives.",
  },
  {
    Id: "17",
    sImg: icon12,
    title: "Performance Metrics and KPI Development",
    slug: "Performance-Metrics-and-KPI-Development",
    description:
      "Our consulting services are customized to suit the unique needs and goals of each client, ensuring precise alignment with their business objectives.",
  },
];

export default Services;
